// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * The default AAD permissions scope for Cognitive Services.
 * @internal
 */
export const DEFAULT_COGNITIVE_SCOPE = "https://cognitiveservices.azure.com/.default";

/**
 * @internal
 */
export const SDK_VERSION = "1.1.0";

/**
 * @internal
 */
export const clientName = "TextAnalysisClient";
